//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import clipboard from "clipboard";
//注册到vue原型上
Vue.prototype.clipboard = clipboard;

export default {
  name: "busSupport",
  data: () => {
    return {
      isSubscribe: false,
      navList: [
        {
          title: "支付方式",
          imgSrc: "../../static/images/busSupport/sim1.png",
          summary: "多种乘车买票方式，灵活选择"
        },
        {
          title: "公交卡服务点",
          imgSrc: "../../static/images/busSupport/excellent.png",
          summary: "公交服务点，中国邮政代充点"
        }
        // {
        //     title: '卡盟',
        //     imgSrc: '../../static/images/busSupport/bag.png',
        //     summary: '卖卡赚钱，佣金丰厚\n您的随身营业厅'
        // },
        // {
        //     title: '会员中心',
        //     imgSrc: '../../static/images/busSupport/member.png',
        //     summary: '专属特权，积分兑换\n彰显尊贵'
        // }
      ],
      busServerLists: [
        {
          name: "大安街",
          address: "南充市顺庆区半边街与大安街交叉口西50米"
        },
        {
          name: "和平东路",
          address: "四川省南充市顺庆区和平东路51号"
        }
      ],
      chinaPostLists: [
        {
          name: "镇江西路"
        },
        {
          name: "西南石油大学"
        },
        {
          name: "延安路"
        },
        {
          name: "西华师大新区"
        },
        {
          name: "人民中路"
        },
        {
          name: "大北街"
        },
        {
          name: "玉带中路"
        },
        {
          name: "红光路"
        },
        {
          name: "建设路"
        },
        {
          name: "白塔路"
        },
        {
          name: "望鹤路"
        },
        {
          name: "火花路"
        },
        {
          name: "光彩大市场"
        }
      ],
      status: 0,
      //切换面板flag
      selected: true,
      selected1: false,
      selected2: false,
      selected3: false,
      temaiSelect: true,
      temaiSelect1: false,
      inputVal: "",
      holderText: "",
      showModelInfo: {
        btn: "确定"
      },
      downModelInfo: {
        showModelStatus: false,
        appImgSrc: "https://www.m10027.com/xiaochengxubanner/kmQRCode.png"
      },
      toastShow: false,
      toastText: ""
    };
  },
  methods: {
    getStatus(navStatus) {
      const navListData = this.navList;
      if (navStatus === 0) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim1.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = true;
        this.selected1 = false;
        // this.selected2 = false;
        // this.selected3 = false;
      } else if (navStatus === 1) {
        navListData[0].imgSrc = "../../static/images/busSupport/sim.png";
        navListData[1].imgSrc = "../../static/images/busSupport/excellent1.png";
        // navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
        // navListData[3].imgSrc = '../../static/images/busSupport/member.png';
        this.selected = false;
        this.selected1 = true;
        // this.selected2 = false;
        // this.selected3 = false;
      }
      // else if (navStatus === 2) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag1.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = true;
      //     this.selected3 = false;
      // } else if (navStatus === 3) {
      //     navListData[0].imgSrc = '../../static/images/busSupport/sim.png';
      //     navListData[1].imgSrc = '../../static/images/busSupport/excellent.png';
      //     navListData[2].imgSrc = '../../static/images/busSupport/bag.png';
      //     navListData[3].imgSrc = '../../static/images/busSupport/member1.png';
      //     this.selected = false;
      //     this.selected1 = false;
      //     this.selected2 = false;
      //     this.selected3 = true;
      // };
      this.status = navStatus;
      this.navList = navListData;
    },
    //选择靓号特卖
    temaiSelectClick: function() {
      this.temaiSelect = true;
      this.temaiSelect1 = false;
    },
    //选择情侣号特卖
    temaiSelect1Click: function() {
      this.temaiSelect = false;
      this.temaiSelect1 = true;
    },
    copyLink: function() {
      let _this = this;
      let clipboard = new this.clipboard(".busServerItem");
      clipboard.on("success", function() {
        _this.toast("复制成功");
      });
      clipboard.on("error", function() {
        _this.toast("复制失败");
      });
    },
    toast: function(str) {
      let v = this;
      v.toastText = str;
      v.toastShow = true;
      setTimeout(function() {
        v.toastShow = false;
      }, 1500);
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/BusSupport.vue